module.exports = __webpack_public_path__ + "static/media/1010677.5c2ef9f5.jpg";